.captionText {
  display: flex;
  justify-content: center;
  align-content: center;
  color: var(--tuna-palette-text-secondary);
}

.clickZone {
  display: flex;
  /* A live upload target, not a disabled one: secondary text meets 4.5:1 */
  color: var(--tuna-content-secondary);
  flex: 1;
  cursor: pointer;
  justify-content: center;
  align-items: center;
}
